import { tclttContent } from "../brandContent/tclttBrandContent";
import BrandLogo from "/static/images/tenants/tcl/logo_tcl.svg";
import { tclttPrize } from "../brandPrize/tcltttPrize";
import { tcl } from "../brandThemes/tcltt";

export const TCLTT_brandVariables = {
  tenantId: "elgiganten-nbxpa", // For picking wich leaderboard to show
  themeId: "tcl",
  gameStyle: "cs2timed", // For picking wich leaderboard to show
  eventCode: "", // Needed for fetching correct challenge
  gameType: "CSGO", // What challenge game
  brandLogoType: "element", // "img" | "element" (svg)
  brandLogo: BrandLogo,
  theme: tcl,
  content: tclttContent,
  prize: tclttPrize,

  leaderboardLength: 9,
  disclaimer: "",
};
